import React, { useEffect, useMemo, useState } from "react"
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from "material-react-table"
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Tooltip,
  Typography,
} from "@mui/material"
import {
  ActiveIcon,
  AchivedIcon,
  MissedIcon,
  LightTooltip,
  OfficeText,
} from "./Atom"
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
} from "../../Modal/UserActivationConfirmation/Atom"
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"
import SyncAltIcon from "@mui/icons-material/SyncAlt"
import { OpportunityDrawer } from "../../Drawer/index"
import OpportunityStatusMenu from "../../Menu/OpportunityStatusMenu"
import MoreActions from "../../Menu/OpportunityActionMenu"
import OpportunityEditGoals from "../../Drawer/OpportunityEditGoalsDrawer"
import MetricAPI from "../../../../api/metric"
import { getCurrentYear, getTokenLocal } from "../../../../helper/utils"
import { useDispatch, useSelector } from "react-redux"
import {
  setOppoortunityOfficeName,
  setOpportunityLogs,
  setOpportunityMoreColumns,
  setOpportunityName,
  setOpportunityStatus,
  setOpportunityPracticeSk,
  setOppoortunityMetricId,
  setOpportunityEditGoalYear,
  setOpportunityEditGoalTable,
  setOpportunityAvailableYears,
  setOpportunityGroupSk,
  setOpportunityRegion,
  setOpportunityFetchId,
  setOpportunityViewHistorical,
} from "../../../redux/slices/metricSlice"
import OpportunityDashboardHistorical from "../../Tooltip/OpportunityDashboardHistorical"
import SortIcon from "@mui/icons-material/Sort"
import { useNavigate } from "react-router-dom"
import { useResponseHandle } from "../../../hooks"
import { setLoading } from "../../../redux/slices/appSlice"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"
import { roundUp } from "../../../../helper/utils/formatting"
import { colors } from "../../../../styles/commonStyles"
import moment from "moment"
import { updateStatusState } from "../../../redux/slices/opportunitySlice"
const metricAPI = new MetricAPI()

export const OpportunityDashboardTable = (props: any) => {
  const dispatch = useDispatch()
  const token: any = getTokenLocal()
  const navigate = useNavigate()
  const { fetchOpportunityTable, loadMoreOpportunities, isLoadingMore } = props

  // Removed debug logs

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isDrawerOpenLogs, setIsDrawerOpenLogs] = useState(false)
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [selectedRowId, setSelectedRowId] = useState("")

  const [data, setData] = useState<any>({})

  const [isEditGoalsOpen, setIsEditGoalsOpen] = useState(false)

  const loading = useSelector((state: any) => state.app.loading)

  const opportunityTableData = useSelector((state: any) => {
    return state.opportunity.opportunityTableData
  })

  const opportunityGroupSk = useSelector((state: any) => {
    return state.metric.opportunityGroupSk
  })

  const opportunityPracticeSk = useSelector((state: any) => {
    return state.metric.opportunityPracticeSk
  })

  const opportunityMetricId = useSelector((state: any) => {
    return state.metric.opportunityMetricId
  })

  const opportunityEditGoalYear = useSelector((state: any) => {
    return state.metric.opportunityEditGoalYear
  })

  //date to check end date
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = String(currentDate.getMonth() + 1).padStart(2, "0")
  const day = String(currentDate.getDate()).padStart(2, "0")
  const formattedDate = `${year}-${month}-${day}`

  const dateFilterHandler = (date: any) => {
    const filteDate = new Date(date)
    const getYear = filteDate.getFullYear()
    dispatch(setOpportunityEditGoalYear(getYear))
  }

  const fetchEditGoals = async () => {
    if (opportunityPracticeSk && opportunityMetricId) {
      const currentYear = getCurrentYear()
      const EditGoals: Array<Object> = []

      const response = await metricAPI.getOpportunityEditGoals(
        token,
        opportunityPracticeSk,
        opportunityMetricId,
        opportunityEditGoalYear || currentYear,
      )

      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        if (result?.statusCode == 200) {
          EditGoals.push(response?.data?.data)
          dispatch(setOpportunityEditGoalTable(EditGoals))
        }
      }

      return result
    }
  }

  const handleDelete = async (id: string) => {
    const response = await metricAPI.deleteOpportunity(token, id)
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        await fetchOpportunityTable()
      }
    }
    return result
  }

  const fetchOpportunityLogs = async () => {
    const Logs: Array<Object> = []

    const response = await metricAPI.getOpportunityLogs(token, data.Id)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        result?.data?.map((ele: any) => {
          const timestamp = ele.log_date

          // Create a Date object from the timestamp
          const date = new Date(timestamp)

          // Get the date components
          const year = date.getFullYear().toString().slice(-2) // Get last 2 digits of the year
          const month = (date.getMonth() + 1).toString().padStart(2, "0") // Add leading zero if needed
          const day = date.getDate().toString().padStart(2, "0") // Add leading zero if needed

          // Create the formatted date string
          const formattedDate = `${month}/${day}/${year}`
          Logs.push({ ...ele, ele, log_date: formattedDate })
        })

        dispatch(setOpportunityLogs(Logs))
      }
    }

    return result
  }

  const fetchMoreColumns = async () => {
    if (data.Id) {
      const MoreColumns: Array<Object> = []
      const response = await metricAPI.getOpportunityMoreColumns(
        token,
        data.Id || "",
      )

      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        if (result?.statusCode == 200) {
          response?.data?.data?.map((ele: any) => {
            MoreColumns.push({ ...ele, ele })
          })
          dispatch(setOpportunityMoreColumns(MoreColumns))
        }
      }

      return result
    }
  }

  const fetchAvailableYears = async () => {
    const response = await metricAPI.getOpportunityAvailableYears(
      token,
      opportunityGroupSk,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(setOpportunityAvailableYears(result?.data))
      }
    }

    return result
  }

  const fetchHistorical = async (id: any, opportunity: any) => {
    dispatch(setOpportunityViewHistorical([]))
    const Historical: Array<Object> = []

    const response = await metricAPI.getOpportunityViewHistorical(token, id)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        Historical.push(response?.data?.data, { opportunity: opportunity })
        dispatch(setOpportunityViewHistorical(Historical))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  const updateMonthGoal = async (data: any) => {
    dispatch(setLoading(true))

    console.log("data", data?.goal_type)

    if (data?.goal_type == "%") {
      data.goal_value = JSON.stringify(parseFloat(data?.goal_value) / 100)
    }

    const response = await metricAPI.setMonthGoals(token, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        await fetchEditGoals()
      }
    }

    dispatch(setLoading(false))

    return result
  }

  const updateStatus = async (data: any) => {
    dispatch(setLoading(true))
    const response = await metricAPI.getOpportunityUpdateStatus(token, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        // await fetchOpportunityTable()
        dispatch(updateStatusState(data))
      }
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))

    return result
  }

  useEffect(() => {
    fetchAvailableYears()
  }, [opportunityGroupSk])

  useEffect(() => {
    fetchEditGoals()
  }, [opportunityEditGoalYear])

  // useEffect(() => {
  //   fetchMoreColumns()
  //   data.Id && fetchOpportunityLogs()
  //   fetchEditGoals()
  //   data.group && fetchAvailableYears()
  // }, [data])

  const [isScrolledToBottom, setIsScrolledToBottom] = React.useState(false)
  const tableContainerRef = React.useRef<HTMLDivElement>(null)

  const opportunityPagination = useSelector((state: any) => {
    return state.opportunity.opportunityPagination
  })

  // Use useEffect to attach scroll listener to the table container
  useEffect(() => {
    const tableContainer = tableContainerRef.current
    if (!tableContainer) return

    const handleScroll = (e: Event) => {
      const target = e.target as HTMLElement
      const scrollTop = target.scrollTop
      const scrollHeight = target.scrollHeight
      const clientHeight = target.clientHeight
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight

      const bottom = distanceFromBottom < 100
      setIsScrolledToBottom(bottom)

      console.log("📜 Scroll detected:", {
        scrollTop: Math.round(scrollTop),
        scrollHeight,
        clientHeight,
        distanceFromBottom: Math.round(distanceFromBottom),
        isBottom: bottom,
        currentPage: opportunityPagination.page,
        totalPages: opportunityPagination.totalPages,
        isLoadingMore,
        canLoadMore:
          opportunityPagination.page < opportunityPagination.totalPages,
      })

      // Trigger load more when scrolled near bottom
      if (bottom && !isLoadingMore && loadMoreOpportunities) {
        console.log("🚀 Triggering loadMoreOpportunities!")
        loadMoreOpportunities()
      }
    }

    tableContainer.addEventListener("scroll", handleScroll)

    return () => {
      tableContainer.removeEventListener("scroll", handleScroll)
    }
  }, [
    opportunityPagination.page,
    opportunityPagination.totalPages,
    isLoadingMore,
    loadMoreOpportunities,
  ])
  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "advisor",
        header: "Advisor",
        size: 160,
        enableSorting: false,
      },
      {
        accessorKey: "office",
        header: "Office",
        size: 230,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <OfficeText>
            <span style={{ fontSize: "14px" }}> {renderedCellValue}</span>
            <span style={{ fontSize: "10px", color: "#a1a1a1" }}>
              {row.original.group_name}
            </span>
          </OfficeText>
        ),
      },
      {
        accessorKey: "opportunity",
        header: "Opportunity",
        size: 230,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <LightTooltip
            sx={{ padding: 0, margin: 0, zIndex: 9999 }}
            title={<OpportunityDashboardHistorical />}
            arrow
            placement={isScrolledToBottom ? "top" : "right"}
            followCursor={false}
          >
            <Typography
              sx={{
                color: "#3366D6",
                fontSize: "14px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onMouseEnter={() => {
                fetchHistorical(row.original.id, row.original.opportunity)
              }}
            >
              {renderedCellValue}
            </Typography>
          </LightTooltip>
        ),
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 160,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span
              style={{
                display: "flex",
              }}
            >
              {renderedCellValue === "active" ? (
                <ActiveIcon />
              ) : renderedCellValue === "achieved" ? (
                <AchivedIcon />
              ) : renderedCellValue === "missed" ? (
                <MissedIcon />
              ) : (
                ""
              )}
            </span>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "uppercase",
                color:
                  renderedCellValue === "active"
                    ? "#3366D6"
                    : renderedCellValue === "achieved"
                    ? "#42B2A0"
                    : renderedCellValue === "missed"
                    ? "#F15854"
                    : "",
              }}
            >
              {renderedCellValue}
            </Typography>
            <span
              onClick={() => {
                dispatch(setOpportunityFetchId(row.original.id))
                dispatch(setOpportunityStatus(row.original.status))
                dispatch(setOpportunityName(row.original.opportunity))
                dispatch(setOppoortunityOfficeName(row.original.office))
                dispatch(setOpportunityPracticeSk(row.original.practice_sk))
                dispatch(setOppoortunityMetricId(row.original.metric_id))
                dispatch(setOpportunityGroupSk(row.original.group_sk))
                dispatch(setOpportunityRegion(row.original.region))
              }}
            >
              {renderedCellValue === "active" ? (
                <PermsWrapper
                  perm={
                    moment(row.original.end_date) < moment()
                      ? permissions.UPDATE_OPPORTUNITY_STATUS_AFTER_EXPIRY
                      : permissions.UPDATE_OPPORTUNITY_STATUS
                  }
                >
                  <OpportunityStatusMenu
                    valueToApply={renderedCellValue}
                    row={row}
                    updateStatus={updateStatus}
                  />
                </PermsWrapper>
              ) : (
                ""
              )}
            </span>
          </Box>
        ),
      },
      {
        accessorKey: "display_start_date",
        header: "Start Date",
        size: 130,
        Header: ({ column }) => (
          <span style={{ paddingRight: " 10px" }}>
            {column.columnDef.header}
          </span>
        ),
      },
      {
        accessorKey: "display_end_date",
        header: "End Date",
        size: 150,
        Header: ({ column }) => (
          <span style={{ paddingRight: " 10px" }}>
            {column.columnDef.header}
          </span>
        ),
        Cell: ({ row, renderedCellValue }: any) => (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ width: "65px" }}> {renderedCellValue}</Box>
            {row.original.status === "active" &&
            row.original.end_date < formattedDate ? (
              <Tooltip
                sx={{ padding: "0px", margin: 0 }}
                title={"Opportunity ended and no action taken"}
                arrow
                placement="right"
              >
                <FiberManualRecordIcon
                  className="blink"
                  sx={{
                    color: "#F15854",
                    width: "12px",
                    height: "12px",
                    marginLeft: "10px",
                  }}
                />
              </Tooltip>
            ) : (
              <Box sx={{ width: "15px", height: "15px" }}></Box>
            )}
          </Box>
        ),
      },
      {
        accessorKey: "target_column",
        header: "Target KPI",
        size: 155,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Typography
            sx={{
              fontSize: "14px",
              textTransform: "capitalize",
            }}
          >
            {renderedCellValue.replace(/_+/g, " ")}
          </Typography>
        ),
      },

      {
        accessorKey: "target_value",
        header: "Start Value",
        size: 145,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Box
            sx={{
              backgroundColor:
                row.original.target_value_highlighting === null
                  ? ""
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "red"
                  ? colors.primaryRed
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "green"
                  ? colors.primaryGreen
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "yellow"
                  ? colors.primaryYellow
                  : "",
              color:
                row.original.target_value_highlighting === null
                  ? ""
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "red"
                  ? colors.primaryWhite
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "green"
                  ? colors.primaryWhite
                  : row.original.target_value_highlighting.toLowerCase() ===
                    "yellow"
                  ? colors.primaryBlack
                  : "",
              padding: "10px",
              textAlign: "center",
            }}
          >
            {renderedCellValue === null ? (
              "N/A"
            ) : (
              <>
                {roundUp(
                  renderedCellValue,
                  row.original.target_column_data_type,
                )}
              </>
            )}
            {/* {renderedCellValue === null ? (
              "N/A"
            ) : row.original.target_column_data_type === "%" ? (
              <>
                {parseFloat(`${renderedCellValue * 100}` || "0").toFixed(2)}
                &nbsp;
                {row.original.target_column_data_type}
              </>
            ) : (
              <>
                {row.original.target_column_data_type}
                &nbsp;
                {renderedCellValue}
              </>
            )} */}
          </Box>
        ),
      },
      {
        accessorKey: "target_current_value",
        header: "Current Value",
        size: 145,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Box
            sx={{
              backgroundColor:
                row.original.target_current_highlighting === null
                  ? ""
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "red"
                  ? colors.primaryRed
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "green"
                  ? colors.primaryGreen
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "yellow"
                  ? colors.primaryYellow
                  : "",
              color:
                row.original.target_current_highlighting === null
                  ? ""
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "red"
                  ? colors.primaryWhite
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "green"
                  ? colors.primaryWhite
                  : row.original.target_current_highlighting.toLowerCase() ===
                    "yellow"
                  ? colors.primaryBlack
                  : "",
              padding: "10px",
              textAlign: "center",
            }}
          >
            {renderedCellValue === null ? (
              "N/A"
            ) : (
              <>
                {roundUp(
                  renderedCellValue,
                  row.original.target_column_data_type,
                )}
              </>
            )}
          </Box>
        ),
      },
      {
        accessorKey: "percent_difference",
        header: "% Difference",
        size: 130,
        enableSorting: false,
        // Cell: ({ row, renderedCellValue }: any) => (
        //   <Typography
        //     sx={{
        //       fontSize: "14px",
        //     }}
        //   >
        //     {renderedCellValue}&nbsp;%
        //   </Typography>
        // ),
        Cell: ({ row, renderedCellValue }: any) => (
          <Box
            sx={{
              border:
                row?.original?.percent_difference_highlighting != null
                  ? "1px solid #FFFFFF"
                  : "none",

              backgroundColor:
                row?.original?.percent_difference_highlighting === "green"
                  ? colors.primaryGreen
                  : row?.original?.percent_difference_highlighting === "red"
                  ? colors.primaryRed
                  : "#FFFFFF",
              color:
                row?.original?.percent_difference_highlighting == null
                  ? colors.primaryBlack
                  : colors.primaryWhite,
              padding: "10px",
              textAlign: "center",
            }}
          >
            {renderedCellValue === null ? (
              "N/A"
            ) : (
              <>{renderedCellValue}&nbsp;%</>
            )}
          </Box>
        ),
      },
      {
        accessorKey: "goal_value",
        header: "Start Goal",
        size: 145,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => {
          return (
            <Typography
              sx={{
                fontSize: "14px",
                textTransform: "capitalize",
              }}
            >
              {renderedCellValue === null ? (
                "N/A"
              ) : (
                <>
                  {roundUp(
                    renderedCellValue,
                    row.original.goal_value_data_type,
                  )}
                </>
              )}
            </Typography>
          )
        },
      },
      {
        accessorKey: "goal_current_value",
        header: "Current Goal Value",
        size: 145,
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Typography
            sx={{
              fontSize: "14px",
              textTransform: "capitalize",
            }}
          >
            {renderedCellValue === null ? (
              "N/A"
            ) : (
              <>
                {roundUp(renderedCellValue, row.original.goal_value_data_type)}
              </>
            )}
            {/* {renderedCellValue === null ? (
              "N/A"
            ) : row.original.goal_value_data_type === "%" ? (
              <>
                {parseFloat(`${renderedCellValue * 100}` || "0").toFixed(2)}
                &nbsp;
                {row.original.goal_value_data_type}
              </>
            ) : (
              <>
                {row.original.goal_value_data_type}
                &nbsp;
                {renderedCellValue}
              </>
            )} */}
          </Typography>
        ),
      },
      {
        //accessorKey: "target_value",
        accessorFn: (row) => `${row.target_value} ${row.target_column}`,
        size: 80,
        header: "Actions",
        enableSorting: false,
        Cell: ({ row, renderedCellValue }: any) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={(event) => {
              setSelectedRowId(row.original.id)
              dispatch(setOpportunityFetchId(row.original.id))
              dispatch(setOpportunityStatus(row.original.status))
              dispatch(setOpportunityName(row.original.opportunity))
              dispatch(setOppoortunityOfficeName(row.original.office))
              dispatch(setOpportunityPracticeSk(row.original.practice_sk))
              dispatch(setOppoortunityMetricId(row.original.metric_id))
              dispatch(setOpportunityGroupSk(row.original.group_sk))
              dispatch(setOpportunityRegion(row.original.region))
              setData({
                Id: row.original.id,
                practiceSk: row.original.practice_sk,
                metricId: row.original.metric_id,
                year: row.original.start_date,
                group: row.original.group_sk,
              })
            }}
          >
            <MoreActions
              row={row}
              setIsDrawerOpen={setIsDrawerOpen}
              setIsEditGoalsOpen={setIsEditGoalsOpen}
              setIsDeleteOpen={setIsDeleteOpen}
              dateFilterHandler={dateFilterHandler}
              fetchAvailableYears={fetchAvailableYears}
            />
          </Box>
        ),
      },
    ],
    [isScrolledToBottom],
    //end
  )

  const table = useMaterialReactTable({
    enablePinning: true,
    state: {
      isLoading: loading,
      columnPinning: { left: ["advisor", "office", "opportunity"] },
    },
    enableStickyHeader: true,
    columns: columns,
    data: opportunityTableData,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: true,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableMultiSort: false,
    muiTableProps: {
      sx: {
        // border: "1px solid rgba(81, 81, 81, 1)",
      },
    },
    muiTableBodyProps: {
      sx: {
        // height: "100%",
      },
    },
    muiTableContainerProps: {
      ref: tableContainerRef,
      sx: {
        // flex: 1,
        height: "72vh",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#3366D6",
        color: "#FFFFFF",
        fontSize: "13px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
        border: "0.5px solid #FFFFFF",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: "14px",
        border: "0.5px solid #00000022",
        py: "0.4rem",
        boxShadow: "#00000022 1.95px 0px 2.6px",
      },
    },
    icons: {
      ArrowDownwardIcon: (props: any) => {
        return <SortIcon sx={{ fill: "#fff" }} {...props} />
      },
      SyncAltIcon: (props: any) => {
        return <SyncAltIcon sx={{ fill: "#fff" }} {...props} />
      },
    },
  })

  return (
    <>
      <MaterialReactTable table={table} />

      {/* Loading indicator for pagination */}
      {isLoadingMore && (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CircularProgress size={20} />
            <Typography variant="body2" color="text.secondary">
              Loading more opportunities...
            </Typography>
          </Box>
        </Box>
      )}

      <OpportunityDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        isDrawerOpenLogs={isDrawerOpenLogs}
        setIsDrawerOpenLogs={setIsDrawerOpenLogs}
        updateStatus={updateStatus}
        fetchMoreColumns={fetchMoreColumns}
        fetchOpportunityLogs={fetchOpportunityLogs}
      />
      <OpportunityEditGoals
        isEditGoalsOpen={isEditGoalsOpen}
        setIsEditGoalsOpen={setIsEditGoalsOpen}
        updateMonthGoal={updateMonthGoal}
      />
      <Dialog
        open={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textAlign: "center", padding: "40px 20px" }}
        >
          Are you sure you want to delete this row?
        </DialogTitle>

        <DialogActions sx={{ borderTop: "1px solid grey", padding: "20px" }}>
          <ButtonContainer>
            <CancelButton onClick={() => setIsDeleteOpen(false)}>
              <Typography color={"#4A79E7"}>Cancel</Typography>
            </CancelButton>
            <ConfirmButton
              onClick={() => {
                handleDelete(selectedRowId)
                setIsDeleteOpen(false)
              }}
            >
              <Typography color={"#ffffff"}>Yes</Typography>
            </ConfirmButton>
          </ButtonContainer>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default OpportunityDashboardTable
